<template>
  <div>
    <div class="box-container">
      <div class="row expanded how-to-box">
        <div class="medium-3 columns">
          <div v-if="!isLoggedIn"
               class="row expanded how-it-item">
            <div class="medium-4 columns reg-how-it"
                 @click="openSignUpModal">
              <!-- <i class="sign in alternate icon"></i>-->
              <img v-if="IS_CORDOVA_APP"
                   :src="trans.firstStepIconUrl"/>
              <img v-else
                   :src="trans.firstStepIconUrl"/>
            </div>
            <div v-if="!isMobileDevice"
                 class="medium-8 columns text-container reg-how-it"
                 @click="openSignUpModal">
              <div class="how-to-text">
                {{ trans.firstStepText }}
              </div>
            </div>
          </div>
          <div v-if="isLoggedIn"
               class="row expanded how-it-item">
            <div class="medium-4 columns">
              <!--<i class="sign in alternate icon"></i>-->
              <img v-if="IS_CORDOVA_APP"
                   :src="trans.firstStepIconUrl"/>
              <img v-else
                   :src="trans.firstStepIconUrl"/>
            </div>
            <div v-if="!isMobileDevice"
                 class="medium-8 columns text-container">
              <div class="how-to-text">{{ trans.firstStepText }}</div>
            </div>
          </div>
        </div>
        <div class="medium-3 columns">
          <div class="row expanded how-it-item">
            <div class="medium-4 columns">
              <!--<i class="search icon"></i>-->
              <img v-if="IS_CORDOVA_APP"
                   :src="trans.secondStepIconUrl"/>
              <img v-else
                   :src="trans.secondStepIconUrl"/>
            </div>
            <div v-if="!isMobileDevice"
                 class="medium-8 columns text-container"
                 @click="scrollClick">
              <div class="how-to-text">{{ trans.secondStepText }}</div>
            </div>
          </div>
        </div>
        <div class="medium-3 columns">
          <div class="row expanded how-it-item">
            <div class="medium-3 columns">
              <!--<i class="calendar check outline icon"></i>-->
              <img v-if="IS_CORDOVA_APP"
                   :src="trans.thirdStepIconUrl"/>
              <img v-else
                   :src="trans.thirdStepIconUrl"/>
            </div>
            <div v-if="!isMobileDevice"
                 class="medium-9 columns text-container"
                 @click="scrollClick">
              <div class="how-to-text">{{ trans.thirdStepText }}</div>
            </div>
          </div>
        </div>
        <div class="medium-3 columns">
          <div class="row expanded how-it-item">
            <div class="medium-4 columns">
              <!--<i class="play icon"></i>-->
              <img v-if="IS_CORDOVA_APP"
                   :src="trans.forthStepIconUrl"/>
              <img v-else
                   :src="trans.forthStepIconUrl"/>
            </div>
            <div v-if="!isMobileDevice"
                 class="medium-8 columns text-container"
                 @click="scrollClick">
              <div class="how-to-text">{{ trans.forthStepText }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import {mapState} from 'vuex'

export default {
  props: ['isMobileDevice', 'isLoggedIn'],
  data () {
    return {
      IS_CORDOVA_APP: config.IS_CORDOVA_APP,
    }
  },
  methods: {
    openSignUpModal () {
      // eslint-disable-next-line
      this.$modal.show('sign-up-modal')
    },
    scrollClick () {
      /* eslint-disable */
      $('html, body').animate({
        scrollTop: ($('.client-container').offset().top - 50),
      }, 500)
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.howItWork,
    }),
  },
}
</script>

<style scoped>
.box-container {
  position: absolute;
  background: #2d3646;
  opacity: 0.9;
  text-align: center;
  width: 100vw;
  left: 0;
  /* top: 33.2rem;*/
  height: 5rem;
  margin-top: -5rem;
}

.box-container img {
  min-height: 50px;
  min-width: 50px;
}

.box-container i {
  color: #FF9000;
  font-size: 250%;
}

.how-to-box {
  padding: 1rem;
}

.text-container {
  margin-top: auto;
  margin-bottom: auto;
  text-align: left;
}

.how-to-text {
  font-weight: 600;
  color: white;
  font-size: 150%;
  display: inline-block;
}

.reg-how-it {
  cursor: pointer;
}

.reg-how-it > i {
  cursor: pointer;
}

.how-it-item {
  cursor: pointer;
}
</style>
